import { createAction } from '@reduxjs/toolkit';
import type { BoundaryFillConfig } from '~/sidebar/sidebarApps/mapTools/boundary/extraFills/extraFills.types';
import type { BoundaryTerritoryGroupId } from '~/store/boundaries/boundaryIdentifier.type';

type AddExtraBoundaryFillPayload = {
  readonly boundaryFillConfig: BoundaryFillConfig;
  readonly boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
};

type UpdateExtraBoundaryFillPayload = AddExtraBoundaryFillPayload;

export const extraBoundaryFillAdded = createAction('BOUNDARY_EXTRA_FILL_ADD',
  (payload: AddExtraBoundaryFillPayload) => ({ payload }));

export const extraBoundaryFillUpdated = createAction('BOUNDARY_EXTRA_FILL_UPDATE',
  (payload: UpdateExtraBoundaryFillPayload) => ({ payload }));

export const extraBoundaryFillRemoved = createAction('BOUNDARY_EXTRA_FILL_REMOVE',
  (payload: { readonly boundaryTerritoryGroupId: number; readonly boundaryFillId: Uuid }) => ({ payload }));

export const extraBoundaryFillActivated = createAction('BOUNDARY_EXTRA_FILL_ACTIVATE',
  (payload: { readonly boundaryTerritoryGroupId: number; readonly extraBoundaryFillId: Uuid }) => ({ payload }));

export const defaultBoundaryFillActivated = createAction('BOUNDARY_DEFAULT_FILL_ACTIVATE',
  (payload: { readonly boundaryTerritoryGroupId: number }) => ({ payload }));

type ExtraFillsPerBoundaryGroupId = {
  readonly [boundaryGroupId: number]: ReadonlyArray<Parameters<typeof extraBoundaryFillAdded>[0]['boundaryFillConfig']>;
};

export const extraBoundaryFillsLoaded = createAction('BOUNDARY_EXTRA_FILL_LOAD',
  (extraFills: ExtraFillsPerBoundaryGroupId) => ({ payload: { extraFills } }));

export const boundaryTerritoryGroupMatchingChanged = createAction('BTG_MATCHING_CHANGED',
  (payload: { readonly boundaryTerritoryGroupId: number }) => ({ payload }));
